export default function ChannelIcon({width,channels}){


  let height = width;

  /*return (
    <div style={{
      minWidth:16,
      height:16,
      background:'green',
    }}/>
  )*/

  let background;
  if( channels ){
    let { colors } = channels;
    let degSpec = colors.map((col,ii) => {
      return `${col} ${ii * 360 / colors.length}deg ${(ii+1) * 360 / colors.length}deg`
    }).join(', ');
    background = `conic-gradient(${degSpec})`
  }
  return (
    <div style={{
      padding:2,
      height,
      minWidth:width,
      borderRadius:width,
      //background:'blue',
      background,//:'conic-gradient(red 120deg, blue 120deg 240deg, lime 240deg 360deg)'
    }}/>
  )

}
